<!-- Error Page -->
<div>
  <div class="mt-fdk-xl">
    <div class="flex justify-center">
      <fdk-illustration name="warning" />
    </div>
    <h2 class="fdk-type-heading-2 text-fdk-primary text-center mt-fdk-l">
      We couldn't verify your identity
    </h2>
    <p
      id="error-message"
      class="fdk-type-paragraph text-fdk-secondary mt-fdk-xxs text-center"
    >
      Check the details below and try again.
    </p>
  </div>

  <div id="error-details" class="bg-gray-100 p-4 rounded-md text-left mt-fdk-m">
    <h3 class="text-md font-medium">Error Details:</h3>
    <p class="text-sm text-gray-800">
      Error Type: <span class="font-semibold">{{ error }}</span>
    </p>
    <p class="text-sm text-gray-800">
      Description: <span>{{ error_description }}</span>
    </p>
  </div>

  <div class="mt-fdk-m flex justify-center">
    <fdk-button [routerLink]="'/auth/identity/verification'" type="button">
      Try Again
    </fdk-button>
  </div>
</div>
